module.exports = __webpack_public_path__ + "img/my.23445506.png";